import Main from "../components/Main.vue";
import NotFound from "../static/NotFound.vue";

export default [
  {
    path: "/",
    component: Main
  },
  { path: "*", component: NotFound }
];
